import { useState } from "react";
import { arrowRight, chevronRight, topNavAccountSelectedAccountTickIcon } from '../../utility-functions/assetLoader';
import { calcPrice } from './PlanModal1';
import Button from '../design/Button';
import './configurePlan.css';
import colors from "../design/colors";
import customStyles from './styles';

const billingOptions = [
    { label: "Monthly", value: "Monthly" },
    { label: "Quarterly", value: "Quarterly" },
    { label: "Annual", value: "Annual" },
];

const plans = [
    {
        id: "STANDARD",
        name: "Standard",
        features: [
            "Call logs & Reports",
            "Call recording",
            "Mobile app",
            "Click to call extension",
        ],
    },
    {
        id: "PROFESSIONAL",
        name: "Professional",
        features: [
            "Everything in Standard plan",
            "Custom reports",
            "Incoming call routing",
            "Call transfer",
            "IVR",
        ],
    },
];

const SelectPlan = ({selectedPlanType, setSelectedPlanType, billingCycle, setBillingCycle, plansData, onClick, isButtonLoading, isButtonDisabled = false}) => {
    const [selectedType, setSelectedType] = useState(selectedPlanType);

    const onPlanChange = (planId) => {
        setSelectedType(planId);
        setSelectedPlanType(planId);
    }

    return (
        <div className="plan-selection-container">
            <div style={{ marginBottom: "1.5rem" }}>
                <h3 style={customStyles.heading}>Choose your plan</h3>
                <p style={customStyles.subheading}>Select the plan that fits your team's needs</p>
            </div>

            <div className="billing-toggle">
                {billingOptions.map((option) => (
                    <div
                        key={option.value}
                        className={`billing-option ${billingCycle === option.value ? "active" : ""}`}
                        onClick={() => setBillingCycle(option.value)}
                    >
                        {option.label}
                    </div>
                ))}
            </div>
            <div className="offer-details">
                Save 5% on quarterly, 15% on annual billing
            </div>

            <div className="plan-container">
                <div className="plans">
                    {plans.map((plan) => {
                        const active = selectedType === plan.id;

                        return (
                            <div
                                key={plan.id}
                                className={`plan-card ${active ? "active" : ""}`}
                                onClick={() => onPlanChange(plan.id)}
                            >
                                <div className="plan-name">{plan.name}</div>
                                <div className="plan-price-row">
                                    <span className="price">{calcPrice(plan.name, plansData, billingCycle)}</span>
                                    <span className="price-unit">/user/mo</span>
                                </div>
                                <div className="plan-features">
                                    {plan.features.map((feature, idx) => (
                                        <div key={idx} className="feature-item">
                                            {topNavAccountSelectedAccountTickIcon("#2eb258", 16, 16)}
                                            <span>{feature}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="compare">
                    <a
                        href="https://frejun.com/pricing/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="compare-link"
                    >
                        Compare plans {chevronRight(colors.nc_gray_1000, 16, 16, {verticalAlign: 'middle'})}
                    </a>
                </div>

                <Button
                    styleOverride={{ marginTop: "2rem", width: "240px" }}
                    hierarchy="green"
                    buttonText="Configure plan"
                    onClick={() => onClick(selectedType)}
                    className="next-btn"
                    disabled={isButtonDisabled || !selectedType}
                    isLoading={isButtonLoading}
                    icon={{endIcon: arrowRight(colors.ic_white)}}
                />
            </div>
        </div>
    )
};

export default SelectPlan;